import React, { Component } from "react";
import { connect } from 'react-redux';
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import { Link } from "react-router-dom";
import Table from "react-bootstrap/Table";
import { confirmAlert } from 'react-confirm-alert'; 
import ReactPaginate from 'react-paginate';
import AddAuthorizationPopUp from "../Modals/AddAuthorization";
import { getAuths } from "../../actions/authorizationActions";
import UserApi from './../../api/user-api';
import apiCallsHelper from '../../api/apiCallsHelper';
import config from '../../common/config';
import ToastService from '../Toasts/toastService';


class FcraPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      searchText: '',
    };
    this.showModal = this.showModal.bind(this);
    this.submitBeginAuthorization = this.submitBeginAuthorization.bind(this);
    this.findAuthorizations = this.findAuthorizations.bind(this);
  }

  showModal() {
    this.setState({ showModal: true });
  }

  findAuthorizations() {
    this.loadAuthorizations(1);
  }

  handlePageClick = e => {
    this.loadAuthorizations(e.selected + 1);
  };

  async componentDidMount() {
    try {
      this.loadAuthorizations(1);
      let user = await UserApi.getUserWithJwt();

      if (user) {
        this.setState({
          user: user
        });
      }
    } catch (error) { }
  }

  loadAuthorizations(page) {
    const req = {
      userId: this.state.user,
      page: page,
      searchText: this.state.searchText
    };
    this.props.getAuths(req);
  }

  submitBeginAuthorization = (id, firstName, lastName, email, user, unique) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui w-50 mx-auto'>
            <h1>Start Authorization Process</h1>
            <p>You are about to initiate the FCRA Authorization process for {firstName} {lastName}.
                <br></br>
                  An authorization email will be sent to {firstName} {lastName} in accordance with the Fair Credit Reporting Act (FCRA). This notice informs the individual of your intent to conduct screening and outlines their rights under FCRA, including the right to review and dispute any inaccurate information.
                <br></br>Please ensure the email address is accurate before proceeding.
                <br></br>Do you want to continue?
                </p>
            <Button variant='outline-secondary mt-3' onClick={onClose}>
              Cancel
            </Button>
            <Button
              variant='success ml-4 mt-3'
              onClick={() => {
                this.handleBeginAuthorization(id, firstName, lastName, email, user, unique);
                onClose();
              }}
            >
              Proceed
            </Button>
          </div>
        );
      }
    });
  };

  async handleBeginAuthorization(id, firstName, lastName, email, user, unique) {
    let data = { id, firstName, lastName, email, user, unique} 
      try{
          const result = await apiCallsHelper.postWithJWT(
            `${config.trueFingerPrintsAPI.baseURL}/approve-auth`, data
          );
          if (result && result.status === 200) {
            ToastService.show(
              'Authorization sent to Individual.',
              'success'
            );
            this.loadAuthorizations(1);
          }
      } catch (error) {
        console.log(error)
      }
  }

 viewAuthorization(id, unique) {
    return `/view-authorization/${unique}`;
  }     

  render() {
    return (
        <Container fluid>
        <Row className='breadcrumb-section'>
          <Col lg={12}>
            <Breadcrumb className='mt-2'>
              <Breadcrumb.Item><Link to='/'>Home</Link></Breadcrumb.Item>
              <Breadcrumb.Item active>Authorization</Breadcrumb.Item>
            </Breadcrumb>
          </Col>
        </Row>
        <Row className='button-action intro-text text-center mb-5'>
          <Col lg={12}>
          <h1>Authorizations</h1>
            <h5 className='mt-4 mb-5'>
              Under FCRA regulations, you must obtain consent before running a CourtRequest—either by sending a pre-existing form for signature or by using the Personnelgraph Authorization feature for automated email and digital signature collection. If consent was obtained manually, you must still create an Authorization on this page before initiating a CourtRequest. Click “Add Authorization” to begin.
            </h5>
              <Button variant='success' size='lg'
                onClick={() => this.showModal( )}
              >    
                <i className='material-icons'>playlist_add</i>Add Authorization
              </Button>
          </Col>
        </Row>
        <Row className="table-section">
          <Col lg={12}>
          <figure className='icon-group mt-5'>
              <h2 className='heading ml-3'>Authorizations</h2>
            </figure>
            <section className="list-box mt-3">
              <Table responsive="xl" className="mb-5">
                <thead>
                  <tr>
                    <th>Authorization</th>
                    <th>FCRA Auth ID</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.authList
                    ? this.props.authList.rows.map(i => {
                      return (    
                        <tr key={i.id}>
                          <td>{i.firstName + " " + i.lastName}</td>
                          <td>{i.status ? i.unique : "" }</td>
                          {i.status === "Y" ?
                          <td>Authorized</td>  
                          : i.status === "N" ?
                          <td className="text-danger">Not Authorized</td> 
                          : <td className="text-warning">Not Authorized - Pending Individual Confirmation</td> 
                          }
                          <td>{i.status !== "N"? 
                            <Button variant="outline-primary" disabled>
                              <i className="material-icons">playlist_add_check</i>
                              Begin Authorization
                            </Button>
                            :
                            <Button variant="outline-primary"  onClick={() => this.submitBeginAuthorization(i.id, i.firstName, i.lastName, i.email, this.state.user.fullName, i.unique)}>
                              <i className="material-icons">playlist_add_check</i>
                              Begin Authorization
                            </Button>
                             }
                          </td>
                          <td>{i.status === "Y" ?
                            <Link to={this.viewAuthorization(i.id, i.unique)}>
                              <Button variant="outline-primary">
                                <i className="material-icons">playlist_play</i>
                                View Authorization
                              </Button>
                            </Link>
                            :
                            <Button variant="outline-primary" disabled>
                              <i className="material-icons">playlist_play</i>
                              View Authorization
                            </Button>
                           }
                          </td>
                        </tr>
                      );
                    })
                    : null}
                </tbody>
              </Table>
              <ReactPaginate
                previousLabel={'< Previous'}
                nextLabel={'Next >'}
                breakLabel={'...'}
                breakClassName={'break-me'}
                pageCount={
                  this.props.authList
                    ? Math.ceil(this.props.authList.count / 10)
                    : 1
                }
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={this.handlePageClick}
                containerClassName={'list-group-pagination pagination'}
                pageClassName={'page-item'}
                pageLinkClassName={'page-link'}
                previousClassName={'page-item'}
                previousLinkClassName={'page-link'}
                nextClassName={'page-item'}
                nextLinkClassName={'page-link'}
                disabledClassName={'page-item disabled'}
                activeClassName={'page-item active'}
              />
            </section>
          </Col>
        </Row>
        {this.state.showModal ? (
          <AddAuthorizationPopUp
            user={this.state.user}
            show={this.state.showModal}
            onHide={() => this.setState({ showModal: false })}
          />
        ) : null}
      </Container>
    );
  }
}

const mapActionsToProps = {
  getAuths: getAuths
};

const mapStateToProps = state => {
  return {
    authList: state.authorizationReducer.authList
  };
};

export default connect(mapStateToProps, mapActionsToProps)(FcraPage);
